exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".category-component{margin:0;width:100%;overflow-x:auto;overflow-y:hidden;text-align:center;background-color:#f5f5f5;z-index:9999}.category-component .category-wrap{width:515px;padding:0 10px;overflow:hidden;background-color:#f5f5f5}.category-component .columns{float:left;padding:0 5px;width:55px}.category-component .button{font-size:14px;color:#999;width:40px;padding:10px 5px;background-color:transparent;margin:0}.category-component .button.active{color:#333;border-bottom:2px solid #333}.fixed{position:fixed;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Category.scss
// module id = 630
// module chunks = 0